<section class="site-status site-status_particles-wrap full-width vh-100 bg-light-2 lato">
    <div class="site-status_particles absolute top-0 left-0 full-width full-height">
        <div *ngFor="let item of totalParticles" class="particle absolute circle"></div>
    </div>
    <article class="content-wrap full-height flex y-items-center x-content-center">
        <div class="txt-center">
            <app-logo></app-logo>
            <h2 class="margin-bottom-10">{{title}}</h2>
            <p class="weight-300 line-height-normal">
                <strong class="block weight-400">{{text}}</strong>
            </p>
        </div>
    </article>
</section>

